/**
 * Whether the array is not empty.
 * @param a An array to check
 * @returns Non-emptiness (as a type guard)
 */
export function isNonEmptyArray(a) {
    return a.length > 0;
}
/**
 * Eliminate empty arrays.
 * @param a A possibly empty array
 * @returns A non-empty array or undefined
 */
export function maybeArray(a) {
    return isNonEmptyArray(a) ? a : undefined;
}
//# sourceMappingURL=nonEmptyArray.js.map